module.exports = __webpack_public_path__ + "img/box-up.50a9ee60.svg";